export function execFunction(fn, args) {
    typeof fn === "function" && fn.apply(undefined, args);
}
//# sourceMappingURL=ExecFunction.js.map